import React from 'react';
import { Language, StampMessage } from '@/types';
import { friendlyTimestamp } from '@/lib/utils';
import { User } from 'lucide-react';
import stampsData from "@/types/stamps.json"

interface StampBubbleProps {
  message: StampMessage;
  preferredLanguage: Language; // To format timestamp
}

export const StampBubble: React.FC<StampBubbleProps> = ({
  message,
  preferredLanguage,
}) => {

  const stampData = stampsData.find((stampData) => stampData.id === message.stampId) || { url: "" };
  return (
    <div
      className={`message-container mb-4 flex flex-col ${
        message.isMe ? "items-end" : "items-start"
      } mb-3 animate-fadeIn`}
      data-timestamp={message.id}
    >
      <div className={`flex flex-col w-40 h-40 bg-contain bg-no-repeat bg-[url(${stampData.url})]`}/>
      {/* User Info Row */}
      <div className={"flex items-center gap-1 py-1 text-xs"}>
        <User size={12} />
        <span className="font-semibold">
          {message.displayUsername}
          {message.isMe ? " (You)" : ""}
        </span>
        <span className="text-neutral-500">•</span>
        <span className="text-neutral-500">
          {friendlyTimestamp(message.timestamp, preferredLanguage)}
        </span>
      </div>
    </div>
  );
};
